
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/email-marketing",
      function () {
        return require("private-next-pages/email-marketing/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/email-marketing"])
      });
    }
  